<template>
    <div class="single-result-search vehicle-component" :class="vehicleClasses">
        <div class="container-single-result-search"
             @click="selectVehicle(vehicle, $event)"
             @contextmenu.prevent="tagPopupModal()">
            <div class="lot">
                <div class="lot-no">
                    <span class="checkbox">
                        <input type="checkbox" :id="'select-vehicle-'+vehicle.api_id"
                               :checked="isSelected" :value="vehicle.api_id"/>

                        <label :for="'select-vehicle-'+vehicle.api_id" @click.stop></label>
                    </span>
                    Lot No. {{ vehicle.lot }}<span class="auction-house">{{
                        displayAuctionHouse(vehicle.auction_house)
                    }}</span>
                </div>
                <div class="recommended" v-if="isRecommendPage && vehicle.recommended_at">
                    <el-tooltip :content="recommendedTitle" placement="bottom" effect="light">
                        <b-badge pill variant="light" >
                            {{recommendedAgo()}}
                        </b-badge>
                    </el-tooltip>
                </div>
                <div class="viewed">
                    <icon icon=" fa-eye" v-if="vehicle.viewed"/>
                </div>
            </div>
            <div class="image-hover-container">
                <vehicle-hover-images :vehicle="vehicle"></vehicle-hover-images>
            </div>
            <div class="image-vehicle">
                <a :href="vehicle.detail_url" @click.exact.stop.prevent="goToCar()" @click.exact.stop.meta
                   @click.exact.stop.ctrl @click.exact.middle.stop>
                    <img width="433" height="325" :src="vehicle.images['front']" alt="Front" loading="lazy"
                         v-if="vehicle.images['front']">
                </a>
            </div>
            <div class="model">
                {{ vehicle.year }} {{ vehicle.make }}
                <span v-html="vehicle.model"></span>
                <span v-if="isTranslatedGrade"
                      v-html="translatedGrades[vehicle.api_id]"
                      :title="`This grade was translated. Original: ${vehicle.grade}`"></span>
                <span v-else v-html="vehicle.grade"></span>
            </div>
            <div class="price-container" v-html="convertCurrency(vehicle)">
            </div>
            <div class="info">
                <div class="info-table">
                    <div class="info-column">
                        <strong>Grade:</strong>
                        <span class="rating">{{ vehicle.condition }}</span>
                    </div>
                    <div class="info-column">
                        {{ vehicle.engine_capacity }}cc
                    </div>
                    <div class="info-column">
                        <span class="mileage">
                            {{ numberWithCommas(vehicle.mileage, 9999) }}Km
                        </span>
                    </div>
                </div>

            </div>
            <div class="details">
                {{ vehicle.transmission }} / {{ convertEquipment(vehicle.equipment) }}
            </div>
            <div :class="timeClasses(vehicle)" :title="getJapanDiff(vehicle.auction_date)">
                {{ getDateTime(vehicle.auction_date).format('h:mma') }} JPN /
                {{ getNZDateTime(vehicle.auction_date).format('h:mma') }} NZ
            </div>
            <template v-if="isSold(vehicle.auction_date)">
                <div v-if="vehicle && vehicle.sold_price" class="sold">
                    <strong>Sold</strong>
                    <br/>
                    <span :title="numberWithCommas(vehicle.sold_price) + ' yen'" class="blue">
                        ¥ {{ numberWithCommas(vehicle.sold_price / 1000) }} k
                    </span>
                </div>
                <div v-else-if="isSold(vehicle.auction_date)" class="sold">
                    <span v-if="vehicle.bid_status === 'negotiation'">negotiation</span>
                    <span v-else-if="vehicle.bid_status === 'cancelled'">Cancelled</span>
                    <span v-else-if="vehicle.bid_status === 'sold'" class="bid-sold">Sold</span>
                    <span v-else class="bid-not-sold">Not sold</span>
                    <template v-if="vehicle.end_price && vehicle.end_price > 0">
                        <br/>
                        <span :title="numberWithCommas(vehicle.end_price) + ' yen'" class="blue">
                        ¥ {{ numberWithCommas(vehicle.end_price / 1000) }} k
                    </span>
                    </template>
                </div>
            </template>
            <div class="view-more">
                <a class="link arrow" :href="vehicle.detail_url" @click.exact.stop.prevent="goToCar()"
                   @click.exact.stop.meta
                   @click.exact.stop.ctrl @click.exact.middle.stop>View more</a>
            </div>
            <div v-for="(bid, element) in vehicle.bids" :style="bidColourStyle(bid)" class="mt-2">
                <div class="p-2" v-if="element == vehicle.bids.length - 1">
                    <div>
                        <a href="#!" @click="filterBidUser(bid.user.id)" class="person">{{ bid.user.name}}</a>
                    </div>
                    <div class="d-flex align-items-start" v-if="bid.bid_price_jpy && bid.bid_price_landed">
                        <div class="mr-2 text-right">
                            <div>Cost</div>
                            <div style="text-transform: uppercase">{{bid.landed_currency}}</div>
                        </div>
                        <div>
                            <div>
                                <template v-if="$userIsAdmin">
                                    ¥ {{ numberWithCommas(bid.bid_price_jpy + bid.bump_bid)}}
                                </template>
                                <template v-else>
                                    ¥ {{ numberWithCommas(bid.bid_price_jpy)}}
                                </template>
                            </div>
                            <div>
                                {{bid.currency_sign}} {{ numberWithCommas(bid.bid_price_landed) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import {
    numberWithCommas,
    getDateTime,
    getNZDateTime,
    getJapanDiff,
    addToUrlQuery, objToUrl,
} from '../../util/common'
import { bidColourStyle, filterBidUser } from '../../util/bid_helper'
import VehicleHoverImages from './VehicleHoverImages'

export default {
    components: {
        VehicleHoverImages
    },
    props: [
        'vehicle',
        'priceField',
        'selected',
    ],
    data() {
        return {
            isTranslatedGrade: false,
            is_favourite: this.vehicle.is_favourite ? true : false,
        }
    },
    created() {
        // Disabled for now because it's costing alot of money
        // this.translateGrade(this.vehicle).then(res => {
        //     if (this.translatedGrades && this.translatedGrades[this.vehicle.api_id]) {
        //         this.isTranslatedGrade = this.translatedGrades[this.vehicle.api_id]
        //     }
        // })
    },
    watch: {
        selected: function (value) {
            this.is_favourite = value
        },
    },
    computed: {
        ...mapState({
            translatedGrades: state => state.auction_search.translated_grades,
        }),
        isSelected() {
            if (this.selected !== undefined) {
                return this.selected
            }
            return !!this.is_favourite
        },
        isRecommendPage(){
            return this.$route.name === 'recommended'
        },
        recommendedTitle(){
            if (this.vehicle.recommended_at) {
                const now = window.moment()
                const date = window.moment(this.vehicle.recommended_at)
                return 'Recommended ' + this.recommendedAgo(false) + ' (' + date.format('DD/MM/YYYY h:mma') + ')'
            }
            return ''
        },
        vehicleClasses() {
            let classes = [];
            if (this.isSelected) {
                classes.push('selected');
            }
            if (this.vehicle.hasOwnProperty('viewed') && this.vehicle.viewed) {
                classes.push('viewed');
            }
            return classes.join(' ');
        },
    },
    methods: {
        ...mapMutations({
            setSingleVehicle: 'auction_search/setSingleVehicle',
        }),
        ...mapActions({
            translateGrade: 'auction_search/translateGrade',
        }),
        numberWithCommas,
        getDateTime,
        getNZDateTime,
        getJapanDiff,
        bidColourStyle,
        filterBidUser,
        recommendedAgo(short = true){
            if (this.vehicle.recommended_at) {
                const now = window.moment()
                const date = window.moment(this.vehicle.recommended_at)
                const secs = Math.abs(date.diff(now, 'seconds'))
                const mins = Math.abs(date.diff(now, 'minutes'))
                let hours = mins / 60
                const extra_mins = (mins / 60) - parseInt(hours)
                if (extra_mins >= 0.75) {
                    hours = Math.ceil(hours)
                } else {
                    hours = Math.floor(hours)
                }
                if (secs > 89) {
                    if (mins > 44) {
                        if (mins < 89) {
                            return short ? `1h` : `1 hour ago`;
                        } else {
                            return short ? `${hours}h` : `${hours} hours ago`;
                        }
                    } else {
                        return short ? `${mins}m` : `${mins} minutes ago`;
                    }
                } else {
                    return short ? `1m` : `1 minute ago`;
                }
            }
            return ''
        },
        displayAuctionHouse(orig_name) {
            let auctionName = '';
            try {
                let name = orig_name.replace(/[^a-zA-Z]/, ' ').replace(/\s{2,}/, ' ');
                // Auction name split in an array
                if (name.indexOf(' ') !== -1) {
                    let arrayName = name.split(' ');
                    // Compose the auction name 2 chars for the first word and 3 chars for the second word.
                    auctionName = arrayName[0].slice(0, 2) + '-' + arrayName[1].slice(0, 3)
                } else if (name.length > 2) {
                } else if (name.length > 2) {
                    auctionName = name.slice(0, 2);
                }
            } catch (err) {
                console.warn('err in displayAuctionHouse', err)
            }
            return auctionName;
        },
        timeClasses(v) {
            let classes = ['time']
            let jap_now = window.moment.tz('Asia/Tokyo')
            let auct = window.moment.tz(v.auction_date, 'Asia/Tokyo')
            if (jap_now > auct) {
                classes.push('auction-done')
            }
            return classes
        },
        convertEquipment(item) {
            let html = ''
            try {
                if (item) {
                    html = item.replace(/ /g, ', ');
                    html = html.toUpperCase();
                }
            } catch (err) {
                console.warn('err in convertEquipment', err)
            }
            return html;
        },
        isSold(auction_date) {
            let date = window.moment.tz(auction_date, 'Asia/Tokyo');
            let now = window.moment.tz(window.moment(), 'Asia/Tokyo');
            return now > date;
        },
        convertCurrency(vehicle) {
            let price = vehicle[this.priceField]
            // let nzdPrice = '$'+ numberWithCommas(Math.round(price / currencyRate['nzd']), 9999) + ' NZD'; //disable this for now..
            let nzdPrice = '';
            let jpyPrice = Math.round(price);
            if (jpyPrice > 999) {
                jpyPrice = numberWithCommas(jpyPrice / 1000, 9999) + 'k';
            } else {
                jpyPrice = numberWithCommas(jpyPrice, 9999);
            }
            let priceDescription = this.priceField === 'end_price' ? 'Final' : 'Start';
            let chassis = ''
            if (vehicle.chassis) {
                let split = vehicle.chassis.split('-');
                chassis = split[0]
            }
            let html = `
                    <div class="currency" :data-currency="vehicle.currency" title="${nzdPrice}">¥</div>
                    <div class="price" title="${nzdPrice}">${jpyPrice}</div>
                    <div class="start" title="${nzdPrice}">
                        <div class="currency-name">JPN</div>
                        <div class="start-auction" title="${nzdPrice}">${priceDescription}</div>
                    </div>
                    <div class="chassis">${chassis}</div>
                `;
            return html;
        },
        selectVehicle(vehicle) {
            if (this.isSelected) {
                this.is_favourite = false
                this.$store.dispatch('favourites/removeFavourite', vehicle.api_id);
            } else {
                this.is_favourite = true
                this.$store.dispatch('favourites/addFavourite', vehicle.api_id);
            }
            this.$emit('select', this.vehicle)
        },
        tagPopupModal($event) {
            if (this.$userCan('fav_list')) {
                this.$emit('tagPopupModal', this.vehicle.api_id, $event)
            }
        },
        goToCar() {
            let url = this.vehicle.detail_url
            this.setSingleVehicle(this.vehicle)
            if (window.history && window.history.state && window.history.state.key) {
                this.$store.dispatch('auction_nextprev/leavingListPage')
                url = addToUrlQuery(url, {state_key: window.history.state.key})
            }
            this.$router.push(url);
        }
    }


}
</script>





// WEBPACK FOOTER //
// resources/js/components/Common/Vehicle.vue